import { config } from '../utils/constants/api.constants';

const { baseUrl, api_version, inventory, scheduledMovement, v2 } =
  config.api.scheduledTasks;

export default (api) => {
  const getScheduledMovements = (params) => {
    const url = `${baseUrl}${api_version}${inventory}${scheduledMovement}${v2}`;
    return new Promise((resolve, reject) => {
      api
        .get(url, params)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getScheduledMovementCount = (params) => {
    const url = `${baseUrl}${api_version}${inventory}${scheduledMovement}/count`;
    return new Promise((resolve, reject) => {
      api
        .get(url, params)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  return {
    getScheduledMovements,
    getScheduledMovementCount,
  };
};
const FILE_VERSION = process.env.REACT_APP_FILE_VERSION;
